export const mainGameId = 197864;

export const redirectLoginUrl = () => {
    if (IS_BERLINGSKE) {
        return "https://www.berlingske.dk/aktiespil"
    } else if (IS_BT) {
        return "https://www.bt.dk/aktiespil"
    } else if (IS_EUROINVESTOR) {
        return "https://www.euroinvestor.dk/aktiespil"
    } else {
        return "https://qa19.bt-testing.dk/aktiespil"
    } 
}


// WEBPACK FOOTER //
// ./src/GameConfig.js